import { getTheme } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";
import { Route, useRouteMatch } from "react-router-dom";

import { Navbar } from "../Navbar";
import { FeedPage } from "./FeedPage";
import { FEED_PATH } from "./paths";

export function SocialContainer() {
  const match = useRouteMatch();

  return (
    <ThemeProvider theme={getTheme()}>
      <Stack sx={{ height: "100%" }}>
        <Route path={`${match.url}/${FEED_PATH}`}>
          <FeedPage />
        </Route>
      </Stack>
      <Navbar />
    </ThemeProvider>
  );
}
